import OT from '@/api/hr/monthly-overtime'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  employees: [],
  year: moment().format('YYYY'),
  month: moment().format('MM')
}

export const getters = {
  getMonth: state => month => {
    let result = state.months.filter(m => m.value === parseInt(month))
    return result.length > 0 ? result[0].text : ''
  }
}

export const mutations = {
  ...baseMutations,
  SET_EMPLOYEE(state, variable) {
    state.employees = variable
  },
  SET_YEAR(state, year) {
    state.year = year
  },
  SET_MONTH(state, month) {
    state.month = month
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        year: context.state.year,
        month: context.state.month
      },
      attributes
    )
    return OT.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return OT.store(data)
  },

  destroy(context, id) {
    return OT.destroy(id)
  },

  update(context, { id, data }) {
    return OT.update(id, data)
  },

  async getEmployee(context) {
    if (!context.state.employees.length > 0) {
      let response = await OT.getEmployee()
      context.commit('SET_EMPLOYEE', response.data)
      return Promise.resolve(response.data)
    }
  }
}
